import Vue from 'vue'
import divider from './common/divider'
Vue.component('divider',divider)